import { toast } from 'react-toastify';

import {
  fetchTables,
  updateComponent,
  createTable,
  updateTable,
  requestRemoveTable,
  requestRemoveAndReplaceTable,
  createSpecial,
  updateSpecial,
  requestToRemoveSpecialTable,
  fetchCovenant,
  createCovenant,
  updateCovenant,
  updateCompulsary
} from './service';

import {
  handleLoading,
  setTables,
  clearPriceTable,
  setCovenant,
  clearCovenant,
  handleCovenant
} from './actions';

export const loadTables = (userId, establishmentId) => dispatch => {
  dispatch(handleLoading(true));

  return fetchTables(userId, establishmentId)
    .then(({ data }) => dispatch(setTables(data)))
    .finally(() => dispatch(handleLoading(false)));
}

export const upsertTable = ({ userId, establishmentId, updateType, ...params }) => dispatch => {
  dispatch(handleLoading(true));

  const { items } = params;
  const formattedItems = items.filter(item => item?.period != 0 || item?.since != 0);

  params.items = formattedItems;

  delete params['originalTypePrice'];
  delete params['deletedAt'];

  if(!updateType) {
    delete params['typePrice'];

    return createTable(userId, establishmentId, params)
      .then(() => {
        toast.success('Tabela cadastrada com sucesso');
        dispatch(clearPriceTable());
        dispatch(loadTables(userId, establishmentId));
      })
      .finally(() => dispatch(handleLoading(false)));
  }

  return updateTable(userId, establishmentId, params)
    .then(() => {
      toast.success('Tabela editada com sucesso');
      dispatch(clearPriceTable());
      dispatch(loadTables(userId, establishmentId));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const changeTableProp = (userId, establishmentId, params, typePrice) => dispatch => {
  dispatch(handleLoading(true));

  return updateComponent(userId, establishmentId, params, typePrice)
    .then(() => {
      toast.success('Tabela atualizada com sucesso');
      dispatch(loadTables(userId, establishmentId));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const removeTable = (userId, establishmentId, typePrice) => dispatch => {
  dispatch(handleLoading(true));

  return requestRemoveTable(userId, establishmentId, typePrice)
    .then(() => {
      toast.success('Tabela removida com sucesso');

      dispatch(clearPriceTable());
      dispatch(loadTables(userId, establishmentId));

      return Promise.resolve();
    })
    .catch(error => {
      if(error.response?.data?.data?.code == '0937') {
        return Promise.reject(error.response?.data?.data?.code);
      }

      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const removeAndReplaceTable = (userId, establishmentId, typePrice, oldTypePrice) => dispatch => {
  dispatch(handleLoading(true));

  return requestRemoveAndReplaceTable(userId, establishmentId, typePrice, oldTypePrice)
    .then(() => {
      toast.success(`Tabela ${oldTypePrice} removida e substituída com sucesso.`);
      dispatch(loadTables(userId, establishmentId));
      return Promise.resolve();
    })
    .catch(() => {
      toast.error(`Houve um erro ao remover e substituir a tabela ${oldTypePrice}`);
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const upsertSpecial = ({ userId, establishmentId, updateType, ...params }) => dispatch => {
  dispatch(handleLoading(true));

  delete params['linkedTable'];

  if(!updateType) {
    delete params['name'];

    return createSpecial(userId, establishmentId, params)
      .then(() => {
        toast.success('Condição especial cadastrada com sucesso');
        dispatch(clearPriceTable());
        dispatch(loadTables(userId, establishmentId));
      })
      .finally(() => dispatch(handleLoading(false)));
  }

  return updateSpecial(userId, establishmentId, params)
    .then(() => {
      toast.success('Condição especial editada com sucesso');
      dispatch(clearPriceTable());
      dispatch(loadTables(userId, establishmentId));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const changeSpecialTableProp = (params, typePrice, description) => dispatch => {
  dispatch(handleLoading(true));

  return updateSpecial(params, typePrice, description)
    .then(() => {
      toast.success('Componente atualizado com sucesso');
      dispatch(loadTables());
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const changeSpecialTablePropCompulsory = (userId, establishmentId, params) => dispatch => {
  dispatch(handleLoading(true));

  return updateCompulsary(userId, establishmentId, params)
    .then(() => {
      toast.success('Componente atualizado com sucesso');
      dispatch(loadTables(userId, establishmentId));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const removeSpecialTable = (userId, establishmentId, params) => dispatch => {
  dispatch(handleLoading(true));

  return requestToRemoveSpecialTable(userId, establishmentId, params)
    .then(({ data }) => {
      toast.success(data.msg);
      dispatch(clearPriceTable());
      dispatch(loadTables(userId, establishmentId));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadCovenant = (userId, establishmentId, typePrice) => dispatch => {
  dispatch(handleLoading(true));

  return fetchCovenant(userId, establishmentId, typePrice)
    .then(({ data }) => {
      return dispatch(setCovenant(data));
    })
    .catch(error => {
      if(error.response.data.data.code == '19001') {
        dispatch(clearCovenant());
      }
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const upsertCovenant = (userId, establishmentId, params) => dispatch => {
  dispatch(handleLoading(true));

  const requestSuccess = (userId, establishmentId, data, text) => {
    toast.success(text);

    dispatch(setCovenant(data));
    dispatch(loadTables(userId, establishmentId));
    dispatch(handleCovenant(false));
  }

  if(!params.accessCode) {
    return createCovenant(userId, establishmentId, params)
      .then(({ data }) => requestSuccess(userId, establishmentId, data, 'Convênio criado com sucesso'))
      .finally(() => dispatch(handleLoading(false)));
  }

  return updateCovenant(userId, establishmentId, params)
    .then((data) => requestSuccess(userId, establishmentId, data, 'Convênio atualizado com sucesso'))
    .finally(() => dispatch(handleLoading(false)));
}